import type { ReactNode } from "react"

import { Toaster } from "@/components/ui/sonner"
import { useOrgTheme } from "@/hooks/use-appearance"
import { useFlash } from "@/hooks/use-flash"
import { usePostHogIdentify } from "@/hooks/use-posthog-identify"

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  useOrgTheme()
  // Runs on every page (including login) and persists across navigations, so
  // logout reaches the reset() branch and re-identification works.
  usePostHogIdentify()
  return (
    <>
      {children}
      <Toaster richColors />
    </>
  )
}
